import { render, staticRenderFns } from "./SensorAlarmHistoryAlarmInfo.vue?vue&type=template&id=1b592f25&"
import script from "./SensorAlarmHistoryAlarmInfo.vue?vue&type=script&lang=js&"
export * from "./SensorAlarmHistoryAlarmInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VChip,VSheet,VSimpleTable})
